import { useEffect, type RefObject } from "react";

export function useInputStyling(inputRef: RefObject<HTMLInputElement | null>, query: string) {
    useEffect(() => {
        const inputEl = inputRef.current;
        if (!inputEl) return;
        const wrapper = inputEl.closest('.algoliaAutocompleteForm__searchBar');
        if (!wrapper) return;

        const updateFilledClass = () => {
            if (inputEl.value.trim()) {
                wrapper.classList.add('is-filled');
            } else {
                wrapper.classList.remove('is-filled');
            }
        };

        const handleFocus = () => wrapper.classList.add('is-focus');
        const handleBlur = () => wrapper.classList.remove('is-focus');

        inputEl.addEventListener('input', updateFilledClass);
        inputEl.addEventListener('focus', handleFocus);
        inputEl.addEventListener('blur', handleBlur);

        updateFilledClass();

        return () => {
            inputEl.removeEventListener('input', updateFilledClass);
            inputEl.removeEventListener('focus', handleFocus);
            inputEl.removeEventListener('blur', handleBlur);
        };
    }, [inputRef]);

    useEffect(() => {
        const inputEl = inputRef.current;
        const wrapper = inputEl?.closest('.algoliaAutocompleteForm__searchBar');
        if (inputEl && wrapper) {
            if (query?.trim()) {
                wrapper.classList.add('is-filled');
            } else {
                wrapper.classList.remove('is-filled');
            }
        }
    }, [query, inputRef]);
}